import React from "react";
import "./Office1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card.jsx";
import iLagoGrandeimages from "../../../Media/Ruko Paramount/iLago Grande/iLagoGrande.js";
import westvillageimages from "../../../Media/Ruko BSD/West Village/westvillage.js";
import HamptonAvenueimages from "../../../Media/Ruko Paramount/Hampton Avenue/Hampton Avenue.js";
import Northpointimages from "../../../Media/Ruko BSD/NTP/Northpoint.js";
import MagioreBusinessimages from "../../../Media/Ruko Paramount/Magiore Business/MagioreBusiness.js";
import Capitalcoveimages from "../../../Media/Ruko BSD/Capital Cove/Capitalcove.js";
import NavaparkBusinessimages from "../../../Media/Ruko BSD/Navapark Business Suites/NavaparkBusiness.js";

const imageMap = {
  iLagoGrandeimages,
  HamptonAvenueimages,
  westvillageimages,
  Capitalcoveimages,
  Northpointimages,
  MagioreBusinessimages,
  NavaparkBusinessimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Briza" className="produk">
      <h1>Office Recommendation for Business </h1>
      <h2>Best Choice Office to Start Your Business</h2>
      <div className="cardhome-container1">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
